module.exports = __webpack_public_path__ + "img/hot.5a4d5fd6.gif";